import { createSelector } from "@reduxjs/toolkit";

import { getIsLoggedIn, getPermissions } from "@/shop/reducers/session/selectors";
import type { IAppStructureNode } from "@/shop/types/appStructure";

import type { IAppStructureStoreState } from "./types";

const getAppStructureState = (state: { appStructure: IAppStructureStoreState }): IAppStructureStoreState => state.appStructure;

export const getAppStructure = createSelector(getAppStructureState, (state) => state.structureTree);

/**
 * Removes nodes
 * - that the user has no permission for
 * - that require login and the user is not logged in
 */
export const getVisibleAppStructure = createSelector(
  getAppStructure,
  getPermissions,
  getIsLoggedIn,
  (appStructure, permissions, isLoggedIn) =>
    appStructure
      .map((node: IAppStructureNode | null) => {
        // of the node requires login and the user is not logged in, we do not show the node
        if (node!.requiresLogin && !isLoggedIn) {
          return null;
        }

        // if the node has a permission and the user does not have the permission, we do not show the node
        if (node!.permission != null && !permissions[node!.permission]) {
          return null;
        }

        return node;
      })
      .filter(Boolean) // remove null values
);
